import React from "react";
import { useNavigate } from "react-router-dom";

import { Button } from "app/components/ui/button";

export const ReadyToBoost = () => {
  const navigate = useNavigate();

  return (
    <section className="px-5 sm:px-6 md:px-7 lg:px-9 xl:px-12">
      <div className="relative w-full max-w-[85.5625rem] text-center bg-[#030208] px-3 sm:px-4 lg:px-5 py-6 sm:py-8 md:py-10 lg:py-14 xl:py-16 2xl:py-20 rounded-2xl md:rounded-3xl lg:rounded-[1.875rem] mx-auto overflow-hidden">
        <div className="absolute top-0 left-0 max-w-80 sm:max-w-[30rem] lg:max-w-[39.07925rem] max-h-[18.7125rem] w-full">
          <img
            src="/assets/group-dots.webp"
            alt="group dots"
            className="object-cover w-full h-full select-none"
            draggable={false}
          />
        </div>
        <h2 className="font-mobile text-white text-2xl sm:text-3xl lg:text-[2.125rem] font-normal leading-8 sm:leading-9 lg:leading-[2.75rem] mb-1 sm:mb-0">
          Ready to Boost Your Platform Driving Income?
        </h2>
        <p className="text-white text-sm sm:text-[0.925rem] lg:text-base font-normal leading-5 sm:leading-[1.375rem] lg:leading-6 mb-4 sm:mb-6 md:mb-8 lg:mb-10 xl:mb-12 2xl:mb-14">
          Switch to VLE Mobile today and experience the difference triple
          network coverage makes for your driving business.
        </p>
        <Button
          type="button"
          variant="ghost"
          className="bg-white hover:bg-white/90 w-fit h-12 sm:h-14 md:h-16 lg:h-[4.25rem] px-8 sm:px-10 md:px-12 lg:px-[3.625rem] rounded-full text-[#1D1D1B] text-sm sm:text-[0.925rem] md:text-base lg:text-lg font-semibold leading-6 sm:leading-7 md:leading-8 lg:leading-[2.28738rem] hover:shadow-md"
          onClick={() => navigate("/network-plan")}
        >
          {/* Start for $1 -&gt; */}
          Get Started -&gt;
        </Button>
      </div>
    </section>
  );
};
